import { IKeyValuePair } from './../../../../_models/common/common';
import { CommonService } from './../../../../shared/services/common.service';
import { IServiceBook } from './../../../../_models/profile-sections/IServiceBook';
import { ProfileService } from './../../../../shared/services/profile.service';
import { IPaged } from '../../../../_models/common/IPaged';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IProfile } from 'src/app/_models/account/IProfile';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ISetting } from 'src/app/_models/cms/ISetting';
import { IServiceBookLog } from 'src/app/_models/profile-sections/IServiceBookLog';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html'
})
export class EmployeeListComponent implements OnInit {
  private readonly PAGE_SIZE = 10;
  profile: IProfile;
  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'UpdatedAt',
    sortDir: 'Descending',
    designationId: '',
    shalaId: '',
    isPrincipalApproved: '',
    financialYearId: ''
  };

  columns = [
    { title: 'Sr.No.', key: 'UserId', isSortable: false },
    { title: 'Name', key: 'FirstName', isSortable: false },
    { title: 'Designation', key: 'Designation', isSortable: false },
    { title: 'School', key: 'School', isSortable: false },
    {},
    {}
  ];

  designations: IKeyValuePair[];
  financialYears: IKeyValuePair[];
  setting: ISetting;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: ProfileService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private settingService: SettingService) {
  }

  ngOnInit() {
    this.settingService.getSetting().then(data => {
      this.setting = data;
      this.query.financialYearId = this.setting?.financialYearId;
    
    this.bindDropDown();
    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort;
        this.query.sortDir = params.sortDir;
        this.query.designationId = params.designationId ? params.designationId : '';
        this.query.shalaId = params.shalaId ? params.shalaId : '';
        this.query.financialYearId = params.financialYearId ? params.financialYearId : this.setting?.financialYearId;
        if (params.hasOwnProperty('isPrincipalApproved')) { 
          if (params.isPrincipalApproved === 'approved') {
            this.query.isPrincipalApproved = "approved";
          } else if (params.isPrincipalApproved === 'rejected') {
            this.query.isPrincipalApproved = "rejected";
          } else if (params.isPrincipalApproved === 'pending') {
            this.query.isPrincipalApproved = "pending";
          } else {
            this.query.isPrincipalApproved = "All"; 
          }
        } else {
          this.query.isPrincipalApproved = "All";  
        }

        this.route.queryParams.subscribe(params => {
          // Get the current URL with the updated query parameters
          const relativeUrl = this.router.url;
          // Store the current URL in localStorage whenever the query params change
          localStorage.setItem('relativeUrl', relativeUrl);
        });
        
          
        if (this.setting?.financialYearId == this.query.financialYearId) {
          this.populateProfiles();
        } else {
          this.populateProfilesLog();
        }
      });
    });
  }

  bindDropDown() {
    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });
    this.commonService.getFinancialYears().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.financialYears = response;
      }
    });
  }

  private populateProfiles() {
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      });
  }
  private populateProfilesLog() {
    this.service.getprofileLog(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      });
  }


  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending";
    }

    this.router.navigate(['/school/employees'], {
      queryParams: this.query
    });
  }

  getServiceBook(v: IServiceBook[]) {
    return v ? v.find(x => x.isPresent == true) : null;
  }
  getServiceBookLog(v: IServiceBookLog[]) {
    return v ? v.find(x => x.isPresent == true) : null;
  } 

  isConfirm(v: IProfile) {
    return v.transferRequests.length > 0 ? v.transferRequests.find(x => x.isConfirm == true) : null;
  }

  openForm(content, v) {
    this.profile = v;
    this.modalService.open(content, { windowClass: 'fade', size: 'xl' });
  }

  closeModal($e) {
    this.modalService.dismissAll();     
    this.populateProfiles();
  }

  onPrincipalStatusChange(status: string) {
    if (status === "All") {
      this.query.isPrincipalApproved = "All"; 
    } else if (status === "pending") {
      this.query.isPrincipalApproved = "pending"; 
    } else if (status === "rejected") {
      this.query.isPrincipalApproved = "rejected";
    }
    else if (status === "approved") {
      this.query.isPrincipalApproved = "approved";
    }
    
  }  
  
  onYearChange(financialYearId: string) {
    this.query.financialYearId = financialYearId;
  
    // Check if the selected financial year is "0", which means "All Years"
    if (financialYearId === '0') {
      this.query.financialYearId = 0;
    } else {
      this.query.financialYearId = financialYearId;
    }
  }

  filter() {
    this.query.page = 1;
    const queryParams: any = { ...this.query };
  
    if (this.query.isPrincipalApproved === "All") {
      queryParams.isPrincipalApproved = "All";
    } else if (this.query.isPrincipalApproved === "pending") {
      queryParams.isPrincipalApproved = "pending"; 
    } else if (this.query.isPrincipalApproved === "rejected") {
      this.query.isPrincipalApproved = "rejected";
    }
    else if (this.query.isPrincipalApproved === "approved") {
      this.query.isPrincipalApproved = "approved";
    }

    if (this.query.financialYearId === '0') {
      this.query.financialYearId = 0;
    } else { 
      this.query.financialYearId; 
    }

    this.router.navigate(['/school/employees'], {
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });
  }
}
